import _ from 'lodash';
export default {
	selectedRowData_({ selectedRow, isNew }) {
		const formData = new FormData();
		for (const [key, val] of Object.entries(selectedRow)) {
			if (!val) continue;
			else if (key === 'fwdImgFile') {
				formData.set(key, val);
			} else formData.append(key, val);
		}
		formData.set('isNew', isNew); //신규 여부
		return formData;
	},
	isPhotoEditable_({ selectedRow }) {
		return selectedRow.lgrpCd === 'PHTG' && selectedRow.creDataScnCd !== 'M' ? true : false;
	},
	hasChanged_({ selectedRow, oldSelectedRow, isNew }) {
		if (isNew) return true;
		if (selectedRow.lgrpCd === 'PHTG') return false;
		return !_.isEqual(selectedRow, oldSelectedRow);
	},
	getLgrpListQ_({ lgrpList }) {
		return lgrpList.filter(el => el.value !== 'POW_QLTY' && el.value !== 'PART_BLO'); //POW_QLTY : 공정품질, PART_BLO : lot 누락
	},
	getLgrpListM_({ lgrpList }) {
		return lgrpList.filter(el => el.value === 'POW_QLTY' || el.value === 'PART_BLO');
	},
	getColumns_(state, getters, rootState, rootGetters) {
		return [
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001122'), //대분류
				prop: 'lgrpNm',
				minWidth: '100px'
			},
			// {
			// 	label: rootGetters['commonStore/getMessage_']('QWCC001122'), //대분류
			// 	prop: 'lgrpCd',
			// 	minWidth: '100px',
			// 	form: {
			// 		type: 'select',
			// 		options: state.lgrpList,
			// 		isDisabled: () => true
			// 	}
			// },
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001123'), //소분류
				prop: 'sgrpNm',
				minWidth: '100px'
			},
			// {
			// 	label: rootGetters['commonStore/getMessage_']('QWCC001123'), //소분류
			// 	prop: 'sgrpCd',
			// 	minWidth: '100px',
			// 	form: {
			// 		type: 'select',
			// 		options: state.sgrpAllList,
			// 		isDisabled: () => true
			// 	}
			// },
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001213'), //방식
				prop: 'ipnWayNm',
				minWidth: '100px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001213'), //방식
				prop: 'ipnWayCd',
				minWidth: '1px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001215'), //항목
				prop: 'ipnPrvsSbc',
				minWidth: '450px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001243'), //중요도
				prop: 'icrtCd',
				minWidth: '1px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001243'), //중요도
				prop: 'icrtNm',
				minWidth: '120px'
			},
			{
				label: 'T(SPEC)', //T
				prop: 'obveScpVal',
				minWidth: '100px'
			},
			{
				label: 'MIN', //MIN
				prop: 'minVal',
				minWidth: '100px'
			},
			{
				label: 'MAX', //MAX
				prop: 'maxVal',
				minWidth: '100px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001124'), //단위
				prop: 'utmCd',
				minWidth: '1px',
				form: {
					type: 'select',
					options: state.utmList,
					isDisabled: () => true
				}
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001124'), //단위
				prop: 'utmNm',
				minWidth: '100px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001244'), //사진
				prop: 'fwdImg',
				minWidth: '80px',
				custom: true
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001163'), //사용여부
				prop: 'useYn',
				minWidth: '1px',
				form: {
					type: 'select',
					options: state.useYnList,
					isDisabled: () => true
				}
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001163'), //사용여부
				prop: 'useYnNm',
				minWidth: '80px'
			}
		];
	},
	getExcelColumns_(state, getters, rootState, rootGetters) {
		return [
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001122'), //대분류
				prop: 'lgrpNm',
				minWidth: '100px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001123'), //소분류
				prop: 'sgrpNm',
				minWidth: '100px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001213'), //방식
				prop: 'ipnWayNm',
				minWidth: '100px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001215'), //항목
				prop: 'ipnPrvsSbc',
				minWidth: '450px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001243'), //중요도
				prop: 'icrtNm',
				minWidth: '120px'
			},
			{
				label: 'T(SPEC)', //T
				prop: 'obveScpVal',
				minWidth: '100px'
			},
			{
				label: 'MIN', //MIN
				prop: 'minVal',
				minWidth: '100px'
			},
			{
				label: 'MAX', //MAX
				prop: 'maxVal',
				minWidth: '100px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001124'), //단위
				prop: 'utmNm',
				minWidth: '100px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001244'), //사진
				prop: 'fwdImgNm',
				minWidth: '80px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001163'), //사용여부
				prop: 'useYnNm',
				minWidth: '80px'
			}
		];
	}
};
